import { initAsyncSlice } from 'aa_common/front-end/zustand'
import { MasterDataService } from 'common/open-api'

import { parseDataMaster } from '../store/masterData/helper'

const getMasterData = async () => {
  const data: any = await MasterDataService.getMasterData()
  const result = parseDataMaster(data.data)
  return {
    data: result,
  }
}
export const masterDataSlice = initAsyncSlice('share/master-data', {}, {}, getMasterData)
